<template>
  <div class="main">
    <video v-if="isPlay" src="/video/exp2-1.mp4" autoplay controls></video>
    <div class="main-box" v-else>
      <img :src="serverURL + 'images/exp2_bg_1.png'" alt="" />
      <div class="play" @click="isPlay = true">
        <img :src="serverURL + 'images/theme/purple-red/exp_item_play.png'" alt="" />
      </div>
    </div>
  </div>
</template>

<script >
export default {
  data() {
    return {
      isPlay: false,
    }
  },
  computed: {
    serverURL() {
      return this.publicData.serverUrl
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0px 2px 24px 0px rgba(239, 226, 202, 0.49);
  video {
    width: 100%;
    height: 100%;
  }
  &-box {
    width: 100%;
    height: 100%;
    position: relative;
    .play {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 130px;
      height: 130px;
      padding: 30px 38px;
      background: radial-gradient(
        circle,
        #ffffff 0%,
        rgba(255, 255, 255, 0.59) 100%
      );
      border-radius: 50%;
      cursor: pointer;
      img {
        width: 100%;
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>